import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '感知重庆·渝味传五洲';
const baseUrl = '20220722GZCQ';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'homelist',
      name: `${baseUrl}-homelist`,
      component: () => import('./pages/HomeList.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'homerank',
      name: `${baseUrl}-homerank`,
      component: () => import('./pages/HomeRank.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'homeDetail',
      name: `${baseUrl}-homeDetail`,
      component: () => import('./pages/HomeDetail.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'homeDetailTwo',
      name: `${baseUrl}-homeDetailTwo`,
      component: () => import('./pages/HomeDetailTwo.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'news',
      name: `${baseUrl}-news`,
      component: () => import('./pages/News.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'rule',
      name: `${baseUrl}-rule`,
      component: () => import('./pages/Rule.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'allrank',
      name: `${baseUrl}-allrank`,
      component: () => import('./pages/AllRank.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
